export default {
  entity: '/units/:id/',
}
